import { DashboardComponent } from "./dashboard/dashboard.component";
import { UserComponent } from "./user/user.component";
import { UserCollectionComponent } from "./user/user-collection.component";
import { UserFilterComponent } from "./user/user-filter.component";
import { AppLoginComponent } from "./login/login.component";
import { ForgotPasswordDialogComponent } from "./login/forgot-password/forgot-password-dialog.component";
import { SuselbeekActivateAccountComponent } from "./login/activate-account/activate-account.component";
import { UserMultipleActivationFilterComponent } from './user/request-multiple-activations/user-multiple-activations-filter.component';
import { AlertComponent } from './alert/alert.component';
import { AlertFilterComponent } from './alert/alert-filter.component';
import { AlertCollectionComponent } from './alert/alert-collection.component';
import { UserLoginHistoryCollectionComponent } from "./login/login-history/login-history-collection.component";


export const componentsExtra = [   
    DashboardComponent,
    UserComponent,
    UserCollectionComponent,
    UserFilterComponent,
    UserMultipleActivationFilterComponent,
    UserLoginHistoryCollectionComponent,

    AppLoginComponent,
    ForgotPasswordDialogComponent,
    SuselbeekActivateAccountComponent,

    AlertComponent,
	AlertFilterComponent,
	AlertCollectionComponent,
];